import axios, { AxiosResponse } from "axios";
export interface CipherBookLetter {
    key: string[];
}

interface CipherBookPhrase {
    key: string;
}

export default class HideAndSeek{
    GlobalCipherBookLetter():CipherBookLetter{
        const book: CipherBookLetter = {
            key: ["c", "a", "t"] // Usaremos "cat" como clave
          };
        return book;
    }

    GlobalCipherBookPhrase():CipherBookPhrase{
        const book: CipherBookPhrase = {
            key: "Honor is dead. But I'll see what I can do." 
          };
        return book;
    }
    
    encryptDecrypt(text: string | number, cipherBook: CipherBookLetter, encrypt: boolean): string | number {
        if (typeof text === 'string') {
            return text
                .split('')
                .map((char, index) => {
                    const keyChar = cipherBook.key[index % cipherBook.key.length].toLowerCase();
                    const shift = keyChar.charCodeAt(0) - 'a'.charCodeAt(0);
                    const encryptedCharCode = encrypt ?
                        (char.charCodeAt(0) + shift - 'a'.charCodeAt(0)) % 26 + 'a'.charCodeAt(0) :
                        (char.charCodeAt(0) - shift - 'a'.charCodeAt(0) + 26) % 26 + 'a'.charCodeAt(0);
                    return String.fromCharCode(encryptedCharCode);
                })
                .join('');
        } else if (typeof text === 'number') {
            const textStr = text.toString();
            const encryptedText = this.encryptDecrypt(textStr, cipherBook, encrypt) as string;
            return parseInt(encryptedText);
        }
        return text;
    }

    encryptDecryptPhrase(text: string | number, cipherBook: CipherBookPhrase, encrypt: boolean): string | number {
        const key = cipherBook.key.toLowerCase(); // Convertir la clave a minúsculas para consistencia

    if (typeof text === 'string') {
        return text
            .split('')
            .map((char, index) => {
                const keyChar = key[index % key.length];
                const shift = keyChar.charCodeAt(0) - 'a'.charCodeAt(0);
                const encryptedCharCode = encrypt ?
                    (char.charCodeAt(0) + shift - 'a'.charCodeAt(0)) % 26 + 'a'.charCodeAt(0) :
                    (char.charCodeAt(0) - shift - 'a'.charCodeAt(0) + 26) % 26 + 'a'.charCodeAt(0);
                return String.fromCharCode(encryptedCharCode);
            })
            .join('');
    } else if (typeof text === 'number') {
        const textStr = text.toString(); // Convertir el número a una cadena de texto
        const encryptedText = this.encryptDecryptPhrase(textStr, cipherBook, encrypt) as string; // Llamar recursivamente con la cadena de texto
        return parseInt(encryptedText, 10); // Convertir el resultado cifrado nuevamente a número
    }
    return text;
    }

    encryptNumber(number: number, cipherBook: CipherBookPhrase): number {
        const key = cipherBook.key.toLowerCase();
        const shift = key.charCodeAt(0) - 'a'.charCodeAt(0);
        const range = 10; // El rango para números es de 0 a 9
    
        // Convertir el número a una cadena y agregar padding a la izquierda con ceros
        const paddedNumber = number.toString().padStart(4, '0');
    
        // Aplicar el cifrado a cada dígito
        const encryptedDigits = paddedNumber.split('').map(digit => {
            let encryptedDigit = (parseInt(digit) + shift) % range;
            return encryptedDigit.toString();
        });
    
        // Unir los dígitos cifrados y convertirlos de nuevo a un número
        return parseInt(encryptedDigits.join(''));
    }
    
    decryptNumber(encryptedNumber: number, cipherBook: CipherBookPhrase): number {
        const key = cipherBook.key.toLowerCase();
        const shift = key.charCodeAt(0) - 'a'.charCodeAt(0);
        const range = 10; // El rango para números es de 0 a 9
    
        // Convertir el número cifrado a una cadena
        const encryptedString = encryptedNumber.toString();
    
        // Aplicar el descifrado a cada dígito
        const decryptedDigits = encryptedString.split('').map(digit => {
            let decryptedDigit = parseInt(digit) - shift;
            if (decryptedDigit < 0) {
                decryptedDigit += range; // Ajustar para asegurar que el número esté dentro del rango
            }
            return decryptedDigit.toString();
        });
    
        // Unir los dígitos descifrados y convertirlos de nuevo a un número
        return parseInt(decryptedDigits.join(''));
    }
}